export default {
  init() {
    // JavaScript to be fired on the home page
	if (window.innerWidth < 768) {
		$('.open-overlay').html('Version texte');
	}
	$(window).resize(function() {
		//small-screen
		if (window.innerWidth < 768) {
			$('.open-overlay').html('Version texte');
		}
		//end small-screen
	});
	$('.open-overlay').click(function(e){
		e.preventDefault();
		$('body').addClass('no-scroll');
		$('.overlay').addClass('open');
		$('.overlay-content').addClass('open');
	});
	$('.btn-close').click(function(){
		$('body').removeClass('no-scroll');
		$('.overlay').removeClass('open');
		$('.overlay-content').removeClass('open');
	});
	$('.overlay').on('click', function(e) {
	if (e.target !== this)
		return;
		$('body').removeClass('no-scroll');
		$('.overlay').removeClass('open');
		$('.overlay-content').removeClass('open');
	});
	$('.grid-content .content').hover(function(){
		$(this).toggleClass('hover');
		$(this.parentNode.children[0]).toggleClass('hover');
	});
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js